export const SUBSCRIPTION_REFRESH_KEY = 'optimise.subscriptionRefreshRequestedAt';

/** Interval (ms) for periodic refetch when user has active subscription. Detects backend deletion. */
export const SUBSCRIPTION_REFETCH_INTERVAL_MS = 5 * 60 * 1000;
